var _circle, _polygon, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelemarketer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 495.415 495.415",
    style: {
      enableBackground: "new 0 0 495.415 495.415"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F220C"
    },
    d: "M231.843,29.015c0,0-6.84-37.152,50.84-27.376c57.688,9.776,113.424,38.136,97.776,175.016 c-15.64,136.88,41.4,102.664,48.888,74.312c0,0-0.984,54.752-44.976,45.952c-44-8.8-81.152-5.864-58.664-84.096 c22.488-78.208,56.064-204.016-78.544-190.656c0,0,4.232,0,6.192,5.864C255.307,33.911,231.843,29.015,231.843,29.015z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 247.707,
    cy: 51.191,
    r: 31.936
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#963877"
    },
    d: "M367.707,152.127c0,17.28-17.512,31.288-39.112,31.288H166.819c-21.6,0-39.112-14.008-39.112-31.288 v-49.424c0-17.28,17.512-31.288,39.112-31.288h161.776c21.6,0,39.112,14.008,39.112,31.288V152.127z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00233F"
    },
    points: "444.715,363.007 295.707,316.831 295.707,303.415 199.707,303.415 199.707,316.839  50.699,363.007 60.539,494.831 60.659,495.415 63.707,495.415 431.707,495.415 431.707,494.079 435.779,494.831 "
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "444.715,363.007 295.707,316.831 295.707,303.415 199.707,303.415 199.707,316.839 50.699,363.447 121.955,495.415  123.251,495.415 60.659,495.415 431.707,495.415 435.579,495.415 435.779,494.831 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E3A1C"
    },
    d: "M350.043,166.551c0,34.56-50.12,62.584-102.336,62.584c-52.184,0-102.328-28.024-102.328-62.584 c0-34.552,50.136-62.568,102.328-62.568C299.915,103.975,350.043,131.991,350.043,166.551z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.707,
    y: 207.415,
    style: {
      fill: "#F9BDA0"
    },
    width: 96,
    height: 112
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAA78C"
    },
    points: "295.707,309.967 295.707,215.415 201.731,215.415 249.427,364.223 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M321.003,135.911c0,70.632-35.816,134.552-73.28,134.552s-73.296-63.92-73.296-134.552 s35.832-82.416,73.296-82.416S321.003,65.271,321.003,135.911z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M247.723,53.495c37.464,0,73.28,11.784,73.28,82.416s-35.816,134.552-73.28,134.552"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E3A1C"
    },
    d: "M257.907,48.847c0,0-68.104,52.144,87.92,114.944c0,0,3-69.112-22.488-99.232 c-25.496-30.12-64.96-26.4-64.96-26.4L257.907,48.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77502A"
    },
    d: "M275.371,40.335c0,0,69.664,69.128-125.72,128.712c0,0-11.52-74.288,18.56-106.12 c30.072-31.832,84.008-26.536,84.008-26.536L275.371,40.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E3A1C"
    },
    d: "M252.219,36.391l27.424,3.328c0,0,96.264,154.64-130,129.328"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA78C"
    },
    d: "M295.707,316.831v-13.416h-96v13.424l-38.864,12.04c5.424,27.416,42.392,48.784,86.352,48.784 s81.6-21.472,87.016-48.888L295.707,316.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F49E14"
    },
    d: "M175.707,192.743c0,8.104-6.568,14.672-14.664,14.672h-2.664c-8.104,0-14.672-6.568-14.672-14.672 v-10.656c0-8.104,6.568-14.672,14.664-14.672h2.664c8.104,0,14.672,6.568,14.672,14.672V192.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B76393"
    },
    d: "M186.411,201.751c1.896,9.848-4.536,19.384-14.408,21.264l0,0 c-9.84,1.904-19.336-4.552-21.248-14.408l-7.864-40.872c-1.888-9.848,4.552-19.352,14.376-21.248l0,0 c9.864-1.896,19.368,4.536,21.272,14.392L186.411,201.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#963877"
    },
    d: "M157.267,146.487L157.267,146.487c9.864-1.896,19.368,4.536,21.272,14.392l7.872,40.872 c1.896,9.848-4.536,19.384-14.408,21.264l0,0c-9.84,1.904-19.336-4.552-21.248-14.408"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F49E14"
    },
    d: "M359.707,182.087c0-8.104-6.568-14.672-14.664-14.672h-2.664c-8.104,0-14.672,6.568-14.672,14.672 v10.656c0,8.104,6.568,14.672,14.664,14.672h2.664c8.104,0,14.672-6.568,14.672-14.672V182.087z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B76393"
    },
    d: "M159.707,252.583c0,1.088,2.928,1.952,4,1.952l0,0c1.088,0,4-0.864,4-1.952v-43.664 c0-1.088-2.912-1.96-4-1.96l0,0c-1.072,0-4,0.872-4,1.96V252.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B76393"
    },
    d: "M192.875,284.071c0.768,0.768,2,0.76,2.76,0l0,0c0.768-0.768,0.768-2,0-2.776l-30.88-30.88 c-0.76-0.76-2.008-0.76-2.768,0.008l0,0c-0.768,0.76-0.768,2.008,0,2.768L192.875,284.071z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F49E14"
    },
    cx: 164.915,
    cy: 252.223,
    r: 5.744
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F27E16"
    },
    d: "M164.915,246.471c3.176,0,5.744,2.584,5.744,5.752s-2.568,5.744-5.744,5.744"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B76393"
    },
    d: "M229.435,287.415c0,4.424-4.816,8-9.232,8h-21.512c-4.416,0-9.464-4.08-9.464-8.496l0,0 c0-4.424,3.312-7.504,7.728-7.504h25.144C226.515,279.415,229.435,282.991,229.435,287.415L229.435,287.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#963877"
    },
    d: "M223.707,287.415h5.728c0,5.216-4.016,8-9.232,8h-21.512c-5.216,0-9.256-2.784-9.256-8h2.272"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F6ED"
    },
    d: "M247.715,467.943c23.624,0,43.232-12.528,47.152-28.528l0,0l0,0c-0.84-1.664,0,0,0,0l0,0 c-3.912-16.2-23.328-27.76-46.944-27.76c-23.648,0-43.456,11.76-47.352,27.76h-0.04c0,0,0.008-0.032,0.008,0h-0.008h0.04 C204.467,455.415,224.067,467.943,247.715,467.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAE9DA"
    },
    d: "M207.707,439.415h-7.184c0,0,0.008-0.032,0.008,0h-0.008h0.04c3.896,16,23.504,28.528,47.152,28.528 c23.624,0,43.232-12.528,47.152-28.528l-0.336,1.208l0,0c0-0.056,0,0,0,0l-1.408-0.44"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EF880C"
    },
    cx: 247.707,
    cy: 441.015,
    r: 22.432
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED690F"
    },
    d: "M247.715,418.615c12.376,0,22.424,10.048,22.424,22.44s-10.048,22.432-22.424,22.432"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5E6664"
    },
    cx: 247.707,
    cy: 441.015,
    r: 9.872
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F423F"
    },
    d: "M254.683,434.071c3.856,3.856,3.856,10.112,0,13.968c-3.848,3.84-10.104,3.84-13.968,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 241.547,
    cy: 433.895,
    r: 4.984
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 254.787,
    cy: 447.575,
    r: 2.272
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelemarketer);
export default __webpack_public_path__ + "static/media/telemarketer.a390c77301f37664c08f814bf0fe3f36.svg";
export { ForwardRef as ReactComponent };